const config = {
  serverDateFormat: 'YYYY-MM-DDTHH:mm:ssZ',
}

export default config
